import { Injectable } from '@angular/core';
import { AccessDataFromToken } from '../models/access-data-from-token.model';
import { InfoPerso } from '../models/info-perso.model';

export type PostLoginNavigationTarget = { commands: string[] } | { url: string };

@Injectable({ providedIn: 'root' })
export class PostLoginNavigationService {
  public isInscriptionComplete(accessData: AccessDataFromToken | null, user: InfoPerso | null): boolean {
    if (!accessData) return false;
    return !!(accessData.contactFirstName && accessData.contactLastName && accessData.contactGender && user && user.cguAcceptation && user.telPrincipal && user.telPrincipal.length > 5);
  }

  // Resolves where to navigate after a successful session init, following the standard/previous/stored/default priority order.
  public resolveInitialRoute(accessData: AccessDataFromToken | null): PostLoginNavigationTarget | null {
    return this.consumeStandardState() ?? this.consumePreviousState() ?? this.consumeStoredRoute() ?? this.getDefaultRoute(accessData);
  }

  private consumeStandardState(): PostLoginNavigationTarget | null {
    const standardState = localStorage.getItem('gs1-ecli-standard-state');
    if (!standardState) return null;
    localStorage.removeItem('gs1-ecli-standard-state');
    return { url: standardState };
  }

  private consumePreviousState(): PostLoginNavigationTarget | null {
    const previousState = localStorage.getItem('gs1-ecli-previous-state');
    if (previousState) {
      localStorage.removeItem('gs1-ecli-previous-state');
      const prevState = JSON.parse(previousState);
      if (prevState?.url?.includes('apim/connexion')) {
        localStorage.setItem('gs1-ecli-state-apim', prevState.url);
      }
      return { url: prevState.url };
    }

    const apimState = localStorage.getItem('gs1-ecli-state-apim');
    if (apimState) {
      localStorage.removeItem('gs1-ecli-state-apim');
      return { url: apimState };
    }

    return null;
  }

  private consumeStoredRoute(): PostLoginNavigationTarget | null {
    const routeStored = localStorage.getItem('gs1-ecli-route-state');
    if (!routeStored) return null;
    return { commands: routeStored.split('/') };
  }

  // Federation users get a special default route; others stay on the current route
  private getDefaultRoute(accessData: AccessDataFromToken | null): PostLoginNavigationTarget | null {
    if (accessData?.privileges?.includes('Féderation')) return { commands: ['/standard'] };
    return null;
  }
}
